<div class="dialog-content-wrapper" style="margin: -24px;">
    <mat-toolbar matDialogTitle class="mat-indigo-800-bg m-0 customBlue">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{translations.lblDocumentForm}} :: {{ data.InvoiceNo.toString().toUpperCase() + ' >> ' + data.C_Name }}</span>
            <button mat-button class="mat-icon-button" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>
    <div mat-dialog-content class="p-24 m-0" style="padding-bottom:0px !important;
    max-height: calc(90vh - 52px);
    height: calc(90vh - 52px);
    overflow: hidden !important;">
        
        <app-secondary-datatable *ngIf="documnetData" #child [parent]="this" fxFlex="1 0 auto" fxFlex.xs="100" fxFlex="50"  (edit)="editRecord($event)" 
            (delete)="deleteRecord($event)" (add)="addRecord()">
            </app-secondary-datatable>

            <form class="mat-white-bg mat-elevation-z4 p-24 mr-24 mb-24" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form" [formGroup]="formGroup" fxFlex.xs="100" fxFlex="47" 
            style="width: 38vw;overflow-y:auto;position: relative;height: calc(80vh) !important;right: -45px !important;float: right;overflow-y: hidden;">
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="100">
                    <input matInput placeholder="{{translations.txtDocumentName}}" formControlName="DocumentName" [(ngModel)]="doc.DocumentName"
                        required>
                    <mat-error *ngIf="formGroupErrors.DocumentName.required">
                        {{translations.msgPleaseEnterDocumentName}}
                    </mat-error>
                </mat-form-field>
               
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                    <input matInput placeholder="{{translations.txtDocumentNo}}" formControlName="DocumentNumber" 
                    [(ngModel)]="doc.DocumentNo">
                </mat-form-field>
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="50">
                    <input matInput [matDatepicker]="dp3" placeholder="{{translations.txtDocRegistrationDate}}" formControlName="RegistrationDate"
                        [(ngModel)]="doc.RegistrationDate" disabled required readonly>
                    <mat-datepicker-toggle matSuffix [for]="dp3"></mat-datepicker-toggle>
                    <mat-datepicker #dp3 disabled="false"></mat-datepicker>
                    <mat-error *ngIf="formGroupErrors.RegistrationDate.required">
                        {{translations.msgPleaseEnterValidDocDate}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="row" fxLayoutAlign="start start">
                <mat-form-field class="mr-24" fxFlex.xs="100" fxFlex="100">
                    <input matInput placeholder="{{translations.txtDocDescription}}" formControlName="Description" [(ngModel)]="doc.Description"
                        required>
                    <mat-error *ngIf="formGroupErrors.Description.required">
                        {{translations.msgPleaseEnterDocDesc}}
                    </mat-error>
                </mat-form-field>
               
            </div>
            <div fxLayout="row" fxLayoutAlign="start start" class="send-in-api">
                <label for="sliderSendInApi" style="float: left;display: inline-block;">{{ translations.lblSendInApi }} ? &nbsp;</label>
                <mat-slide-toggle style="float: right;display: inline-block;margin-right: 20px;" id="sliderSendInApi" formControlName="SendInApi" [checked]="doc.SendInApi" [(ngModel)]="doc.SendInApi">
                  
                </mat-slide-toggle>
            </div>
   
            <mat-form-field style="display: none !important">
                <input matInput formControlName="FilePath" [(ngModel)]="doc.FilePath"
                    required style="display: none !important">                
            </mat-form-field>
            
             
            <div fxLayout="row" fxLayoutAligh="start start">
                <div class="mr-24" fxFlex.xs="100" fxFlex="100">
                    <input type="file" placeholder="{{translations.txtFile}}" name="FileName" required multiple style="display:none;" id="fileInput" (change)="fileChangeEvent($event)"
                    accept=".jpg,.jpeg,.png,.pdf">
                    <file-drop headertext="{{translations.txtFile}}" (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)" (onFileLeave)="fileLeave($event)">
                    <i _ngcontent-c28="" class="material-icons md-48" color="accent"
                     style="color: #02488e;
                     float: left;
                     left: 40px;
                     position: absolute;
                    font-size: 32px;cursor:pointer;    margin-top: -6px;"  (click)="openFileDialogue();">add_box</i>
                     
                   
                    </file-drop>           
                </div>
            </div>
            
            <div fxLayout="row" fxLayoutAligh="start start">
                <mat-list role="list" class="mr-24" fxFlex.xs="100" fxFlex="100" style="background:#fafafa;height: calc(90vh - 500px);
                overflow-y: auto;">
                    <mat-list-item role="listitem" *ngFor="let file of fileList">
                        <div fxFlex.xs="100" fxFlex="70">
                            <mat-icon class="mat-icon material-icons" role="img" aria-hidden="true">{{imageFileType.indexOf(file.FileType) < 0 ? 'insert_drive_file' : 'image'}}</mat-icon>
                            <label style="display: block;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            width: calc(100% - 24px);
                            float: right;
                            line-height: 24px;">{{file.FileName}}</label>
                        </div>
                        <!-- <mat-progress-bar fxFlex.xs="100" fxFlex="30" mode="determinate" 
                        id="pb_{{file.Id}}"
                        color="accent"
                        value="{{file.Progress}}" *ngIf="file.FilePath == ''"></mat-progress-bar> -->
                        <a href="{{file.HttpPath}}" target="_blank" style="cursor: pointer;right: 40px;
                        position: absolute;" *ngIf="file.HttpPath != ''" >
                            <mat-icon class="mat-icon material-icons" role="img" aria-hidden="true" >remove_red_eye</mat-icon>
                        </a>
                        <a style="cursor: pointer;right: 15px;position: absolute;" *ngIf="file.Status && file.HttpPath != ''" (click)="changeFileStatus(file,false)">
                            <mat-icon class="mat-icon material-icons" role="img" aria-hidden="true" >delete_forever</mat-icon>
                        </a>
                        <a style="cursor: pointer;right: 15px;position: absolute;" *ngIf="(!file.Status) && file.HttpPath != ''" (click)="changeFileStatus(file,true)">
                            <mat-icon class="mat-icon material-icons" role="img" aria-hidden="true" >undo</mat-icon>
                        </a>
                        <a style="cursor: pointer;right: 15px;position: absolute;" *ngIf="file.HttpPath == ''" (click)="removeFrmList(file)">
                            <mat-icon class="mat-icon material-icons" role="img" aria-hidden="true" >close</mat-icon>
                        </a>
                        
                    </mat-list-item>                
                </mat-list>                
            </div>
       
            <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="right">
                    <button mat-raised-button color="accent" aria-label="SAVE"  fxFlex="50" 
                    [disabled]="formGroup.invalid" (click)="save();">
                        {{translations.btnSave}}
                    </button>
                    <button mat-raised-button color="warn" aria-label="CLOSE" mat-dialog-close fxFlex="50">
                        {{translations.btnClose}}
                    </button>
                </div>
        </form>
    </div>
</div>


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/order/document-detail/document-detail.component.html